// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"87783534","37":"03a812e1","421":"a9295ef3","453":"34c7869a","818":"6a16463a","865":"c0eb2fae","883":"631d529e","889":"bfed2cc9"}[chunkId] + ".chunk.js";
};